// Define all possible environment variables
interface EnvConfig {
  apiBaseUrl: string;
  debug: boolean;
  sentryAuthToken?: string;
  [key: string]: string | boolean | undefined;
}

// Get all VITE_ prefixed environment variables
const getEnvVars = (): EnvConfig => {
  const env: EnvConfig = {
    apiBaseUrl: '',
    debug: false,
  };

  // Get all VITE_ prefixed variables from import.meta.env
  Object.entries(import.meta.env).forEach(([key, value]) => {
    if (key.startsWith('VITE_')) {
      // Convert the key to camelCase and remove VITE_ prefix
      const configKey = key
        .replace('VITE_', '')
        .toLowerCase()
        .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

      // Convert string 'true'/'false' to boolean
      if (value === 'true' || value === 'false') {
        env[configKey] = value === 'true';
      } else {
        env[configKey] = value;
      }
    }
  });

  return env;
};

// Validate required environment variables
const validateEnv = (env: EnvConfig): EnvConfig => {
  const requiredVars = ['apiBaseUrl'];
  const missingVars = requiredVars.filter(key => !env[key]);

  if (missingVars.length > 0) {
    throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
  }

  return env;
};

// Export validated environment configuration
export const env = validateEnv(getEnvVars()); 